import React from "react";
import Button from "components/CustomButtons/Button.js";
import EmailIcon from '@material-ui/icons/Email';

function EmailButton({email}) {
    return (
        <div className="actions-right">
            <Button
            justIcon
            round
            simple
            onClick={() => {
                // let obj = data.find(o => o.id === key);
                window.open(`mailto:${email}`, '_blank')
                // window.location.href = `mailto:${obj.email}`
            }}
            color="info"
            className="like"
            >
                <EmailIcon />
            </Button>{" "}
        </div>
    )
}

export default EmailButton